module.exports = __webpack_public_path__ + "static/PostGrotesk-Bold-010191fe423ee1e85e2e844f90a7fa44.eot";